import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { isEmpty, keys, pickBy } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';
import useWindowSize from '../../../hooks/useWindowSize';
import queryString from 'query-string';

import { array } from 'prop-types';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobModal from '../../../components/BobModal';
import CreateSiteModal from '../SitePage/CreateSiteModal';
import DeleteSiteModal from '../SitePage/DeleteSiteModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import PreviewWeatherDataModal from '../Modals/PreviewWeatherDataModal';

import {dashboardContent} from '../../../localization/en-us/dashboardContent';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './Table.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const SitesTable = ({
    activeNavCompany,
    bobLoading,
    companies,
    createSiteModalOpen,
    subscribeToAlertsSiteModalOpen,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    deleteSiteModalOpen,
    fetchDashboardData,
    fetchNavClients,
    fetchSingleSite,
    fetchNavSites,
    history,
    handleToggleCreateSiteModal,
    handleToggleSubscribeToSiteAlertsModal,
    handleToggleDeleteSiteModal,
    resetNavOptions,
    refreshTab,
    setRefreshTab,
    setNavClient,
    setNavCompany,
    setNavSite,
    setTableProps,
    searchTerm,
    siteFilters,
    sites,
    sitesMeta,
    targetNavCompany,
    targetNavSite,
    totalsData,
    workbookModeEnabled,
    ...props
}) => {
    const [sortFilter] = useState('');
    const [typeFilters, setTypeFilters] = useState([]);
    const [priorityFilters, setPriorityFilters] = useState([]);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [site, setSite] = useState(null);
    const [dataState, setDataState] = useState(initialDataState);
    const [siteColumnWidth, setSiteColumnWidth] = useState(250);
    const [previewWeatherDataModalOpen, setPreviewWeatherDataModalOpen] = useState(false);

    const queryValues = queryString.parse(history.location.search);
    const companyId = queryValues.company;

    const isInitialMount = useRef(true);
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = columnList.map((c) => {
            c.width = c.field === 'siteName' ? 250 : c.width;
            if (c.field.toLowerCase().includes('faultcount')) {
                c.show = dashboardIsCurrentTimeStamp;
            }
            else {
                c.show = true;
            }
            return c;
        });

        const colWidth = calculateMinColumnWidths(columns.filter(c => c.show), gridDivRef.current.offsetWidth, 'siteName', 250, true);
        setSiteColumnWidth(colWidth);
        columns.find(c => c.id === 'siteColumn').width = colWidth;
        setColumnList(columns);

    }, [windowSize, dashboardIsCurrentTimeStamp]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
        setColumnList(columnList.map(c => {
            c.filterable = c.actionCell ? false : workbookModeEnabled;
            return c;
        }));
    }, [workbookModeEnabled]);

    useEffect(() => {
        setSkip(0);
        setTake(10);
    }, [companyId]);

    useEffect(() => {
        if (siteFilters.type || Object.values(siteFilters.priority).includes(true)) {
            const typeFilters = siteFilters.type.map(filter => filter.id);
            const priorityFilters = keys(pickBy(siteFilters.priority));

            setTypeFilters(typeFilters);
            setPriorityFilters(priorityFilters);
        }
    }, []);

    useEffect(() => {
        if (activeNavCompany && activeNavCompany.name && isEmpty(sites)) {
            initializeFetch();
        }
    }, [activeNavCompany]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (siteFilters.type || Object.values(siteFilters.priority).includes(true)) {
                if (!isEmpty(targetNavCompany) && !isEmpty(sitesMeta)) {
                    initializeFetch();
                }
            } else {
                const init = async () => {
                    initializeFetch();
                };
                
                if (activeNavCompany.id && !isEmpty(sites)) init();
            }
        }
    }, [siteFilters, dashboardStartTimeStamp, dashboardEndTimeStamp, searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            let page = 1;
            
            if ( skip && take ) {
                page = skip / take + 1;
            }

            if (sortFilter) {
                await fetchDashboardData(activeNavCompany.id, 'CompanySite', { sort: sortFilter, searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            } else {
                await fetchDashboardData(activeNavCompany.id, 'CompanySite', { sort: 'default^desc', searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            }

            setRefreshTab();
        };

        if (refreshTab) refresh();
    }, [refreshTab]);
    
    const initializeFetch = async () => {
        setSkip(0);

        const typeFilters = siteFilters.type.map(filter => filter.id);
        const priorityFilters = keys(pickBy(siteFilters.priority));

        setTypeFilters(typeFilters);
        setPriorityFilters(priorityFilters);

        if (!isEmpty(searchTerm)) {
            setTableProps({
                search: searchTerm,
                sort:   sortFilter
            });
        }
        
        if (sortFilter) {
            await fetchDashboardData(activeNavCompany.id, 'CompanySite', { sort: sortFilter, limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        } else {
            await fetchDashboardData(activeNavCompany.id, 'CompanySite', { sort: 'default^desc', limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        }
    };

    const fetchSiteListAfterCreate = async (body, type) => {
        handleToggleCreateSiteModal(false);

        // If you created a new site, set the nav options to the new site.
        if (type === 'create') {
            await setNavClient({
                name: body.clientName,
                id:   body.clientId
            });

            fetchNavSites(body.clientId);

            setNavSite({
                name: body.name,
                id:   body.id
            });
        }

        setSkip(0);

        // If you updated site, refresh the site table
        if (type === 'update') {
            await fetchDashboardData(activeNavCompany.id, 'CompanySite', { sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        }
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `site?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/site';

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        } else {
            resetNavOptions('site');
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        await fetchSingleSite(queryValues);
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <Link
                    to={renderNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td className={props.className} style={props.style}>
                <img className={ props.dataItem[props.field] > 0 ? classes.IconImage: classes.IconImageGray} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const scoresCell = props => {
        let value = props.dataItem[props.field];
        value = value.toString().includes('.') ? parseFloat(value).toFixed(2) : value;

        return (
            <td className={props.className} style={props.style}>
                {value + '%'}
            </td>
        );
    };

    const fetchSites = async searchTerm => {
        setSkip(0);

        await fetchDashboardData(activeNavCompany.id, 'CompanySite', { sort: 'default^desc', searchFilter: searchTerm, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const handleEditSite = (siteData) => {
        setSite(siteData);
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=7d2489e6-4481-481a-8fbf-d5c0262c6539&company=${activeNavCompany.id}&entityId=${siteData.siteId}&entityParent=${siteData.clientId}&entityType=site&parentId=7e71f5d4-9fbf-4710-8601-e1f11e681479`,
                state:    { 'returnUrl': `/v2/dashboard/company?appId=${bob.key}&childId=181b15f1-dae9-4258-89ef-07941ff33025&company=${activeNavCompany.id}&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4` }
            })
            :
            handleToggleCreateSiteModal(true);
    };

    const handlePreviewWeatherData = siteData => {
        setSite(siteData);
        setPreviewWeatherDataModalOpen(true);
    };

    const subscribeSiteData = (siteData) => {
        siteData.name = siteData.siteName;
        siteData.id = siteData.siteId;

        setSite(siteData);
        handleToggleSubscribeToSiteAlertsModal(true);
    };

    const fetchSiteDataForDelete = (siteData) => {
        setSite(siteData);
        handleToggleDeleteSiteModal(true);
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    type="site"
                    entityData={props.dataItem}
                    onSubscribeAlerts={(entityData) => {subscribeSiteData(entityData);}}
                    onDelete={(entityData) => {fetchSiteDataForDelete(entityData);}}
                    onFetch={(entityData) => handleEditSite(entityData)}
                    onPreviewWeatherData={(entityData) => handlePreviewWeatherData(entityData)}
                />
            </td>
        );
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const actionFilterCell = props => {
        return (
            <div />
        );
    };

    const defaultColumnList = [
        {
            title:       dashboardContent.site,
            field:       'siteName',
            id:          'siteColumn',
            cell:        nameCell,
            width:       350,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: false
        },
        {
            title:       dashboardContent.client,
            field:       'clientName',
            width:       225,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.buildingType,
            field:       'buildingTypeName',
            width:       200,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.location,
            field:       'siteLocation',
            width:       200,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.campus,
            field:       'campusName',
            width:       150,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.equipment,
            field:       'equipmentCount',
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.score,
            field:       'siteScore',
            cell:        scoresCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.faults,
            field:       'totalFaultCount',
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.high,
            field:       'highFaultCount',
            cell:        priorityCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.medium,
            field:       'mediumFaultCount',
            cell:        priorityCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.low,
            field:       'lowFaultCount',
            cell:        priorityCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       '',
            field:       '',
            cell:        actionsCell,
            locked:      true,
            sortable:    false,
            filterable:  false,
            filterCell:  actionFilterCell,
            width:       75,
            show:        true,
            actionCell:  true,
            reorderable: false
        }
    ];
    const [columnList, setColumnList] = useState(defaultColumnList);

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef} 
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(sites, dataState)}
                    {...dataState}
                    pageable={pageable}
                    onDataStateChange={onDataStateChange}
                    reorderable={true}
                    filterable={workbookModeEnabled}
                >
                    {
                        bobLoading.includes('CompanySite') || isEmpty(sitesMeta) ?
                            <GridNoRecords>
                                Loading sites
                            </GridNoRecords>
                            :
                            null
                    }
                    {
                        columnList.map(
                            (column, index) => 
                                column.show && (
                                    <Column
                                        key={index}
                                        field={column.field}
                                        title={column.title}
                                        id={column.id}
                                        cell={column.cell}
                                        width={column.id === 'siteColumn' ? siteColumnWidth : column.width}
                                        filter={column.filter}
                                        filterCell={column.filterCell}
                                        sortable={column.sortable}
                                        filterable={column.filterable}
                                        locked={column.locked}
                                        reorderable={column.reorderable}
                                    />
                                )
                        )
                    }                    
                </Grid>
                {
                    subscribeToAlertsSiteModalOpen ?
                        <CreateSubscriptionModal
                            parent={site}
                            parentLabel="Site"
                            handleToggleSubscribeToAlertsModal={handleToggleSubscribeToSiteAlertsModal}
                        />
                        :
                        null
                }
                {
                    createSiteModalOpen ?
                        <BobModal
                            title={site ? 'Edit Site' : 'Add New Site'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                setSite(null);
                                handleToggleCreateSiteModal(false);}}
                        >
                            <CreateSiteModal
                                site={site}
                                isEdit={site ? true : false}
                                fetchSiteListAfterCreate={(body, type) => fetchSiteListAfterCreate(body, type)}
                                onClose={() => {
                                    setSite(null);
                                    handleToggleCreateSiteModal(false);}}
                            />
                        </BobModal> : ''
                }
                {
                    previewWeatherDataModalOpen ?
                        <PreviewWeatherDataModal
                            site={{ name: site.siteName, id: site.siteId }}
                            onClose={() => setPreviewWeatherDataModalOpen(false)}
                        />
                        :
                        null
                }
                {
                    deleteSiteModalOpen ?
                        <BobModal
                            title={'Delete Entity'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                handleToggleDeleteSiteModal(false);}}
                        >
                            <DeleteSiteModal
                                site={site}
                                fetchSites={fetchSites}
                                onClose={() => {handleToggleDeleteSiteModal(false);}}
                            />
                        </BobModal> : ''
                }
                {
                    bobLoading.includes('CompanySite') || isEmpty(sitesMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

SitesTable.defaultProps = {
    sites: []
};

SitesTable.propTypes = {
    sites: array
};

const mapStateToProps = state => ({
    activeNavCompany:            state.bob.activeNavCompany,
    bobLoading:                  state.bob.bobLoading,
    companies:                   state.core.companies,
    companyTabIndex:             state.dashboard.companyTabIndex,
    dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
    dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    siteFilters:                 state.dashboard.siteFilters,
    sites:                       state.dashboard.sites,
    sitesMeta:                   state.dashboard.sitesMeta,
    targetNavCompany:            state.bob.targetNavCompany
});

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SitesTable));
